module.exports = __webpack_public_path__ + "img/vk_back.f4408329.png";